module.exports = __webpack_public_path__ + "static/media/HindVadodara-Bold.e1d98836.woff";